import _Object$freeze from "@babel/runtime-corejs3/core-js-stable/object/freeze";import { validateDateOfBirth } from "../../helpers/validateDateOfBirth";
















// A list of regexes that are used across the project.
export var REGEXES_MAPPING = _Object$freeze({
  strongPassword: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/),
  emailValid: new RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),

  validUSAPhoneNumber: new RegExp(/^[2-9][0-9]{9}$/),
  onlyNumbers: new RegExp(/^\d+$/),
  onlyLetters: new RegExp(/^[a-zA-Z]+$/),
  validName: new RegExp(/^[A-Za-z\s-.',]+$/),
  validNpn: new RegExp(/^\d{1,9}$/),
  printableCharacters: new RegExp(/[ -~]+$/),
  validSSN: new RegExp(/^[0-9]{3}-[0-9]{2}-[0-9]{4}$/)
});

// The list of the available validations;

























// A list of the validations objects.
export var VALIDATIONS_RULES = _Object$freeze({
  isPasswordStrong: {
    check: function check(value) {return REGEXES_MAPPING.strongPassword.test(value);},
    msg: 'Password must contains at least 1 lowercase, 1 uppercase alphabetical character, 1 numeric character and must be eight characters or longer'
  },
  isEmailValid: {
    check: function check(value) {return REGEXES_MAPPING.emailValid.test(value);},
    msg: 'Email address should be valid.'
  },
  isValidUSAPhoneNumber: {
    check: function check(value) {return REGEXES_MAPPING.validUSAPhoneNumber.test(value);},
    msg: 'The phone number should contain only digits, cannot start from 0 or 1 and be no longer than 10 numbers.'
  },
  containsOnlyNumbers: {
    check: function check(value) {return REGEXES_MAPPING.onlyNumbers.test(value);},
    msg: 'Only numbers allowed.'
  },
  isTierChildAgeValid: {
    check: function check(value) {return validateDateOfBirth(value, 25);},
    msg: 'Should not be older than 26 years old.'
  },
  isTierSpouseAgeValid: {
    check: function check(value) {return validateDateOfBirth(value, 130);},
    msg: 'Should not be older than 130 years old.'
  },
  containsOnlyLetters: {
    check: function check(value) {return REGEXES_MAPPING.onlyLetters.test(value);},
    msg: 'Should contain only letters.'
  },
  validName: {
    check: function check(value) {return REGEXES_MAPPING.validName.test(value);},
    msg: 'Field contains unsupported symbols'
  },
  validNpn: {
    check: function check(value) {return REGEXES_MAPPING.validNpn.test(value);},
    msg: 'Npn should contain only up to 9 digits'
  },
  printableCharacters: {
    check: function check(value) {return REGEXES_MAPPING.printableCharacters.test(value);},
    msg: 'Field contains unsupported symbols'
  },
  validSSN: {
    check: function check(value) {return REGEXES_MAPPING.validSSN.test(value);},
    msg: 'Valid format for SSN is XXX-XX-XXX'
  }
});
//# sourceMappingURL=validationsMapping.js.map